import { render, staticRenderFns } from "./brochurForm.vue?vue&type=template&id=fbb8c44a&scoped=true"
import script from "./brochurForm.vue?vue&type=script&lang=js"
export * from "./brochurForm.vue?vue&type=script&lang=js"
import style0 from "./brochurForm.vue?vue&type=style&index=0&id=fbb8c44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb8c44a",
  null
  
)

export default component.exports